<template>
  <footer class="app-footer">
    <div class="footer-main">
      <div class="container footer-content">
        <div class="footer-col footer-brand">
          <div class="footer-logo">
            <span class="logo-text">Brilliantet海外留学</span>
          </div>
          <p class="footer-desc">{{ company.slogan || '精准留学，智启未来' }}</p>
          <p class="footer-desc" v-if="company.description">{{ company.description?.substring(0, 120) }}...</p>
        </div>
        <div class="footer-col">
          <h4>快速导航</h4>
          <router-link to="/">首页</router-link>
          <router-link to="/about">关于我们</router-link>
          <router-link to="/services">服务项目</router-link>
          <router-link to="/cases">成功案例</router-link>
          <router-link to="/news">新闻资讯</router-link>
          <router-link to="/contact">联系我们</router-link>
        </div>
        <div class="footer-col">
          <h4>服务项目</h4>
          <router-link to="/services">留学申请规划</router-link>
          <router-link to="/services">文书润色指导</router-link>
          <router-link to="/services">面试辅导培训</router-link>
          <router-link to="/services">签证办理服务</router-link>
          <router-link to="/services">背景提升方案</router-link>
        </div>
        <div class="footer-col">
          <h4>联系我们</h4>
          <p v-if="company.phone"><strong>电话：</strong>{{ company.phone }}</p>
          <p v-if="company.email"><strong>邮箱：</strong>{{ company.email }}</p>
          <p v-if="company.wechat"><strong>微信：</strong>{{ company.wechat }}</p>
          <p v-if="company.address"><strong>地址：</strong>{{ company.address }}</p>
          <p v-if="company.business_hours"><strong>营业：</strong>{{ company.business_hours }}</p>
        </div>
      </div>
    </div>
    <div class="footer-bottom">
      <div class="container">
        <p>{{ company.copyright || '&copy; 2024 Brilliantet海外留学 版权所有' }}
          <span v-if="company.icp" style="margin-left: 16px">{{ company.icp }}</span>
        </p>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { getCompanyInfo } from '../api'

const company = ref({})

onMounted(async () => {
  try {
    company.value = await getCompanyInfo()
  } catch (e) {
    // ignore
  }
})
</script>

<style scoped>
.app-footer {
  background: #1a1f36;
  color: #ccc;
  margin-top: auto;
}

.footer-main {
  padding: 60px 0 40px;
}

.footer-content {
  display: grid;
  grid-template-columns: 1.5fr 1fr 1fr 1.2fr;
  gap: 40px;
}

.footer-brand {
  padding-right: 40px;
}

.footer-logo {
  display: flex;
  align-items: baseline;
  gap: 6px;
  margin-bottom: 16px;
}

.footer-logo .logo-text {
  font-size: 22px;
  font-weight: 700;
  color: #fff;
}

.footer-logo .logo-sub {
  font-size: 14px;
  color: #999;
}

.footer-desc {
  font-size: 14px;
  line-height: 1.8;
  color: #999;
  margin-bottom: 8px;
}

.footer-col h4 {
  font-size: 16px;
  color: #fff;
  margin-bottom: 20px;
  font-weight: 600;
}

.footer-col a {
  display: block;
  color: #999;
  font-size: 14px;
  padding: 5px 0;
  transition: color 0.3s;
}

.footer-col a:hover {
  color: #fff;
}

.footer-col p {
  font-size: 14px;
  line-height: 2;
  color: #999;
}

.footer-col p strong {
  color: #ccc;
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  padding: 20px 0;
  text-align: center;
  font-size: 13px;
  color: #666;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 30px;
  }

  .footer-brand {
    padding-right: 0;
  }
}
</style>
